import logger from '@/commons/logger';
import { err } from '@/commons/toast';
import { HttpError } from '@/store/models';
import { i18n } from '@/i18n';

const errorMapper = [
    {
        condition: (errResp: any) => {
            return errResp.parameters && errResp.parameters.length === 2 && errResp.parameters[0] === 'matrixrate';
        },
        message: i18n.t('Check zip code').toString(),
    },
];

export default function(e: any, dolog = true, doNotify = true, errorCode: any = false) {
    let toLogErr: any;
    let message = '';
    if (e.isAxiosError) {
        const typedErr: HttpError = e;
        if (typedErr.response.status === 500) {
            message = i18n.t('Service unavailable, retry later').toString();
        } else {
            message = i18n.t(typedErr.response.data.message).toString();
        }

        let mapMatched = false;
        for (const errMap of errorMapper) {
            if (errMap.condition(typedErr.response.data)) {
                mapMatched = true;
                message = errMap.message;
                break;
            }
        }

        if (typedErr.response.data.parameters && !mapMatched) {
            let i = 1;
            typedErr.response.data.parameters.forEach((errParam) => {
                message = message.replace('%' + i, errParam);
                i++;
            });
        }
        if (doNotify) {
            err(message);
        }
        toLogErr = {
            url: typedErr.config.url,
            code: typedErr.response.status,
            errmess: message,
            payload: typedErr.config.data,
        };
        if (errorCode) {
            toLogErr.errorCode = errorCode;
        }
    } else {
        toLogErr = e;
        if (errorCode) {
            toLogErr = {
                exception: e,
                errorCode,
            };
        }
        if (doNotify) {
            err(e);
        }
    }
    // console.log('Logging error');
    if (dolog) {
        logger.error(toLogErr);
    }
    return { message };
}
